<template>
  <v-main>
    <v-layout class="ma-2" justify-center>
      <v-card class="px-5 px-2 rounded-xl" width="1200" >
        <v-card-title>
          Adicionar Exames ao médico
        </v-card-title>
        <v-divider class="mb-4" />

        <v-text-field v-model="nomeMedico" disabled :type="'text'" name="input-10-1" label="Nome do médico" counter></v-text-field>

        <v-form v-model="valid" ref="form1">
          <div class="d-flex align-center">
            <v-autocomplete
              v-model="servicoSelecionado"
              return-object
              no-data-text="Nenhum serviço disponível"
              :items="servicosMedico"
              item-text="nomeEspecialidade"
              label="Serviço"
              :rules="[(v) => !!v || 'Você deve escolher um serviço para continuar']"
              hint="Escolha um serviço"
              persistent-hint
              class="flex-grow-1 mr-2"
            ></v-autocomplete>

            <v-btn
              icon
              color="error"
              @click="limparServico"
              :disabled="!servicoSelecionado"
              title="Limpar serviço selecionado"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <v-alert :value="erroEditar" color="error" icon="warning" outlined>
            Erro ao editar nome !!
          </v-alert>

          <v-alert :value="erroId" color="error" icon="warning" outlined>
            Escolha um medico na lista de médicos !!
          </v-alert>
          <v-alert :value="erroServicosIguais" color="error" icon="warning" outlined>
            Serviços já cadastrados para este Médico
          </v-alert>

          <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
            Sucesso ao cadastrar exames serviços do médico !!
          </v-alert>
        </v-form>

        <v-form v-model="valid2" ref="form2">
          <!-- Campo de busca para exames -->
          <v-text-field
            v-model="listaExamesDoMedicoBusca"
            label="Buscar exame por nome"
            disabled
            :loading="mostrarLoading"
            :hint="servicoSelecionado ? 'Buscar exames do serviço selecionado' : 'Buscar todos os exames por nome'"
            persistent-hint
            clearable
            @input="onBuscarExame"
            @click:clear="limparBuscaExame"
          >
            <template v-slot:append>
              <v-icon>mdi-magnify</v-icon>
            </template>
          </v-text-field>

          <!-- Painel expansível para mostrar resultados da busca -->
          <v-expand-transition>
            <v-card v-if="listaExamesRetornados.length > 0 && listaExamesDoMedicoBusca" class="mb-4" outlined>
              <v-card-text>
                <div class="d-flex justify-space-between align-center mb-2">
                  <v-card-title class="pa-0 subtitle-1">
                    Resultados da busca ({{ listaExamesRetornados.length }} exames encontrados)
                    <v-chip small class="ml-2" color="primary">
                      {{ listaExamesDoMedico.length }} selecionados
                    </v-chip>
                  </v-card-title>
                  <v-btn small text @click="expandirResultados = !expandirResultados">
                    {{ expandirResultados ? 'Recolher' : 'Expandir' }}
                  </v-btn>
                </div>

                <v-expand-transition>
                  <div v-if="expandirResultados">
                    <v-chip
                      v-for="exame in listaExamesRetornados"
                      :key="exame.idExame"
                      class="ma-1"
                      :color="isExameSelecionado(exame.idExame) ? 'primary' : 'default'"
                      :text-color="isExameSelecionado(exame.idExame) ? 'white' : 'black'"
                      @click="toggleExameSelecionado(exame)"
                      close
                      @click:close="removerExameSelecionado(exame)"
                    >
                      <v-icon left v-if="isExameSelecionado(exame.idExame)">mdi-check</v-icon>
                      {{ exame.nomeExame }}
                    </v-chip>

                    <div class="mt-3">
                      <v-btn small @click="selecionarTodosResultados" class="mr-2">
                        <v-icon left>mdi-check-all</v-icon>
                        Selecionar Todos
                      </v-btn>
                      <v-btn small @click="limparSelecaoResultados" class="mr-2">
                        <v-icon left>mdi-close-box</v-icon>
                        Limpar Seleção
                      </v-btn>
                      <v-btn small @click="usarResultadosBusca">
                        <v-icon left>mdi-check</v-icon>
                        Usar Estes Exames
                      </v-btn>
                    </div>
                  </div>
                </v-expand-transition>
              </v-card-text>
            </v-card>
          </v-expand-transition>

          <!-- Autocomplete de exames (oculto durante busca) -->
          <v-expand-transition>
            <v-autocomplete
              v-if="!listaExamesDoMedicoBusca || listaExamesRetornados.length === 0"
              v-model="listaExamesDoMedico"
              no-data-text="Nenhum exame disponível"
              :items="listaExamesRetornados"
              return-object
              item-value="idExame"
              item-text="nomeExame"
              :rules="[(v) => v && v.length > 0 || 'Escolha um ou mais exames para cadastrar']"
              label="Exames"
              :hint="servicoSelecionado ? 'Exames do serviço selecionado' : 'Todos os exames disponíveis'"
              chips
              persistent-hint
              multiple
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggle">
                  <v-list-item-action>
                    <v-icon :color="listaExamesDoMedico.length > 0 ? 'indigo darken-4' : ''">
                      {{icon}}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{msgSelecionarTudo}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
          </v-expand-transition>

          <!-- Mostrar exames selecionados durante a busca -->
          <v-expand-transition>
            <div v-if="listaExamesDoMedicoBusca && listaExamesDoMedico.length > 0" class="mb-4">
              <v-card outlined>
                <v-card-title class="subtitle-1">
                  Exames Selecionados ({{ listaExamesDoMedico.length }})
                </v-card-title>
                <v-card-text>
                  <v-chip
                    v-for="exame in listaExamesDoMedico"
                    :key="'selected-' + exame.idExame"
                    class="ma-1"
                    color="primary"
                    close
                    @click:close="removerExameSelecionado(exame)"
                  >
                    <v-icon left>mdi-check</v-icon>
                    {{ exame.nomeExame }}
                  </v-chip>
                </v-card-text>
              </v-card>
            </div>
          </v-expand-transition>

          <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Voce deve concordar para cadastrar!']" required></v-checkbox>

          <v-alert :value="erroEditar" color="error" icon="warning" outlined>
            Erro ao editar nome !!
          </v-alert>

          <v-alert :value="erroId" color="error" icon="warning" outlined>
            Escolha um medico na lista de médicos !!
          </v-alert>
          <v-alert :value="erroServicosIguais" color="error" icon="warning" outlined>
            Serviços já cadastrados para este Médico
          </v-alert>

          <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
            Sucesso ao alterar Exames do médico !!
          </v-alert>

          <v-card-actions>
            <v-spacer />
            <v-btn rounded dark @click="cadastrarExameMedico" :class="{ red: !valid2, green: valid2 }">Cadastrar</v-btn>
            <v-btn rounded outlined @click="voltar" to='/listaMedicosUnidade'>
              <v-icon left>keyboard_backspace</v-icon>
              voltar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-layout>
  </v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'editarUnidade',
  components: {},
  data () {
    return {
      listaExamesDoMedicoBusca: '',
      buscaTimeout: null,
      expandirResultados: false,
      erroEditar: false,
      idMedico: '',
      VariavelAlterou: true,
      erroId: false,
      nomeMedico: '',
      codigoServicoSelecionado: '',
      MensagemSelecionarTodos: '',
      mostrarListaExames: false,
      mostrarListaServicos: true,
      mostrarLoading: false,
      erroServicosIguais: false,
      servicosEscolhidos: '',
      servicosMedico: [],
      servicosMedicoInicial: [],
      examesEscolhidos: [],
      servicoSelecionado: null,
      listaExamesRetornados: [],
      listaDeExamesServico: [],
      listaExamesDoMedico: [],
      listaExamesDoMedicoInicial: [],
      sucessoEditar: false,
      exameInicial: [],
      isEditing: true,
      listaServicos: [],
      listaServicosUnidade: [],
      nomeEspecialidade: '',
      valid: true,
      valid2: true,
      checkbox: false,
      user: null,
      nomeRules: [
        (v) => v && v.length > 5 || 'nome deve ter mais de 5 caracteres'
      ],
      items: [{
        nomeEspecialidade: 'Cardiologia',
        idServico: 1,
        quantVagas: 1,
        idLocal: 1
      },
      {
        nomeEspecialidade: 'Urologia',
        idServico: 3,
        quantVagas: 2,
        idLocal: 2
      },
      {
        nomeEspecialidade: 'Cirugia',
        idServico: 2,
        quantVagas: 10,
        idLocal: 3
      },
      {
        nomeEspecialidade: 'Ultrasom',
        idServico: 4,
        quantVagas: 10,
        idLocal: 4
      },
      {
        nomeEspecialidade: 'Cirugia 3',
        idServico: 5,
        quantVagas: 11,
        idLocal: 5
      },
      {
        nomeEspecialidade: 'Cirugia 4',
        idServico: 6,
        quantVagas: 11,
        idLocal: 6
      }]
    }
  },
  mounted () {
    console.log('em mounted cadst. medic servic')
    console.log(this.$route.params.item)
    if (!this.$route.params.item) {
      this.$router.push('/listaMedicosUnidade')
      return
    }

    this.user = this.$store.getters.usuario
    this.idMedico = this.$route.params.item.idMedico
    this.nomeMedico = this.$route.params.item.nome
    this.erroEditar = false
    console.log(this.idMedico)
    this.retornarServicosMedico()
    this.sucessoEditar = false
  },

  computed: {
    escolheuTodosExames () {
      return this.listaExamesDoMedico.length === this.listaExamesRetornados.length
    },

    escolheuAlgunsExames () {
      return this.listaExamesDoMedico.length > 0 && !this.escolheuTodosExames
    },

    msgSelecionarTudo () {
      if (this.escolheuTodosExames) return 'Remover todos'
      if (this.escolheuAlgunsExames) return 'Selecionar todos'
      return 'Selecionar todos'
    },

    icon () {
      if (this.escolheuTodosExames) return 'mdi-close-box'
      if (this.escolheuAlgunsExames) return 'mdi-checkbox-intermediate'
      return 'mdi-checkbox-blank-outline'
    }
  },

  methods: {
    isExameSelecionado (idExame) {
      return this.listaExamesDoMedico.some(exame => exame.idExame === idExame)
    },

    toggleExameSelecionado (exame) {
      if (this.isExameSelecionado(exame.idExame)) {
        this.removerExameSelecionado(exame)
      } else {
        this.listaExamesDoMedico.push(exame)
      }
    },

    removerExameSelecionado (exame) {
      const index = this.listaExamesDoMedico.findIndex(e => e.idExame === exame.idExame)
      if (index > -1) {
        this.listaExamesDoMedico.splice(index, 1)
      }
    },

    selecionarTodosResultados () {
      this.listaExamesDoMedico = [...this.listaExamesRetornados]
    },

    limparSelecaoResultados () {
      this.listaExamesDoMedico = []
    },

    usarResultadosBusca () {
      // Fecha a busca e mantém a seleção
      this.listaExamesDoMedicoBusca = ''
      this.expandirResultados = false
    },

    limparServico () {
      this.servicoSelecionado = null
      this.listaExamesRetornados = []
      this.listaExamesDoMedico = []
      this.listaExamesDoMedicoBusca = ''
      this.expandirResultados = false
      this.$refs.form1.resetValidation()
    },

    onBuscarExame () {
      if (this.listaExamesDoMedicoBusca && this.listaExamesDoMedicoBusca.trim().length >= 2) {
        clearTimeout(this.buscaTimeout)
        this.buscaTimeout = setTimeout(() => {
          this.buscarExamesPorNome()
        }, 500)
      } else if (this.listaExamesDoMedicoBusca === '') {
        this.retornarExames()
      }
    },

    buscarExamesPorNome () {
      this.mostrarLoading = true
      this.mostrarListaServicos = false

      const textoBusca = this.listaExamesDoMedicoBusca || ''

      administradorUnidadeService.administradorUnidade
        .retornarExamesParent(
          this.servicoSelecionado ? this.servicoSelecionado.idExameEspecialidade : null,
          this.servicoSelecionado ? this.servicoSelecionado.parent : null,
          textoBusca
        )
        .then(rsp => {
          console.log('rsp busca:', rsp.data)
          this.mostrarLoading = false
          this.mostrarListaExames = true
          this.listaExamesRetornados = rsp.data
          this.expandirResultados = true // Expande automaticamente ao buscar
          console.log('lista exames retornados busca', this.listaExamesRetornados)

          // Se há um serviço selecionado, carrega os exames do médico
          if (this.servicoSelecionado) {
            this.retornarExamesMedico()
          }
        })
        .catch(err => {
          this.mostrarLoading = false
          this.mostrarListaServicos = true
          console.log(err)
        })
    },

    limparBuscaExame () {
      this.listaExamesDoMedicoBusca = ''
      this.expandirResultados = false
      this.retornarExames()
    },

    voltar () {
      this.erroServicosIguais = false
      this.mostrarListaServicos = true
      this.mostrarListaExames = false
      this.$refs.form2.reset()
      this.listaExamesRetornados = []
      this.listaExamesDoMedico = []
      this.listaExamesDoMedicoBusca = ''
      this.expandirResultados = false
    },

    toggle () {
      this.$nextTick(() => {
        if (this.escolheuTodosExames) {
          this.listaExamesDoMedico = []
        } else {
          this.listaExamesDoMedico = this.listaExamesRetornados.slice()
        }
      })
    },

    retornarExames () {
      // Se não há serviço selecionado mas há texto de busca, faz busca por nome
      if (!this.servicoSelecionado && this.listaExamesDoMedicoBusca) {
        this.buscarExamesPorNome()
        return
      }

      if (this.servicoSelecionado) {
        this.mostrarLoading = true
        this.mostrarListaServicos = false

        const textoBusca = this.listaExamesDoMedicoBusca || ''

        administradorUnidadeService.administradorUnidade
          .retornarExamesParent(
            this.servicoSelecionado.idExameEspecialidade,
            this.servicoSelecionado.parent,
            textoBusca
          )
          .then(rsp => {
            console.log('rsp oi:', rsp.data)
            this.mostrarLoading = false
            this.mostrarListaExames = true
            this.listaExamesRetornados = rsp.data
            console.log('lista exames retornados', this.listaExamesRetornados)
            this.retornarExamesMedico()
          })
          .catch(err => {
            this.mostrarLoading = false
            this.mostrarListaServicos = true
            console.log(err)
          })
      }
    },

    retornarServicosUnidade () {
      console.log('em retornar servico unidade...')
      administradorUnidadeService.administradorUnidade
        .retornarServicosUnidade(this.user.idUnidade)
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          this.listaServicosUnidade = rsp.data
          console.log(this.listaServicosUnidade)
        })
        .catch(err => {
          console.log(err)
        })
    },

    retornarServicosMedico () {
      console.log('em retornar servicos medicos...')
      administradorUnidadeService.administradorUnidade
        .retornarServicosMedico(this.idMedico)
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          this.servicosMedico = rsp.data
          this.servicosMedicoInicial = rsp.data
        })
        .catch(err => {
          console.log(err)
        })
    },

    retornarExamesMedico () {
      if (!this.servicoSelecionado) return

      administradorUnidadeService.administradorUnidade
        .retornarExamesMedico(this.servicoSelecionado.idServico, this.idMedico)
        .then(rsp => {
          console.log('em retornar exames medico:', rsp.data)
          this.listaExamesDoMedico = rsp.data
          this.listaExamesDoMedicoInicial = rsp.data
        })
        .catch(err => {
          this.mostrarLoading = false
          this.mostrarListaServicos = true
          console.log(err)
        })
    },

    montarExamesPayload () {
      const examesIniciais = Array.isArray(this.listaExamesDoMedicoInicial) ? this.listaExamesDoMedicoInicial : []
      const examesAtuais = Array.isArray(this.listaExamesDoMedico) ? this.listaExamesDoMedico : []
      const inicialIds = new Set(examesIniciais.map(exame => exame.idExame))
      const atualIds = new Set(examesAtuais.map(exame => exame.idExame))
      const payload = []

      examesAtuais.forEach(exame => {
        if (!inicialIds.has(exame.idExame)) {
          payload.push({ idExame: exame.idExame, status: 1 })
        }
      })

      examesIniciais.forEach(exame => {
        if (!atualIds.has(exame.idExame)) {
          payload.push({ idExame: exame.idExame, status: 0 })
        }
      })

      if (payload.length === 0 && examesAtuais.length > 0) {
        return examesAtuais.map(exame => ({ idExame: exame.idExame, status: 1 }))
      }

      return payload
    },

    cadastrarExameMedico () {
      if (this.$refs.form2.validate()) {
        console.log('entrou no form..')
        this.erroServicosIguais = false
        const examesAux = this.montarExamesPayload()

        console.log('fim da picada', examesAux)

        administradorUnidadeService.administradorUnidade
          .cadastrarExameMedico(this.idMedico, this.servicoSelecionado ? this.servicoSelecionado.idMedicoServico : null, examesAux, this.servicoSelecionado.idServico)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)

            if (rsp.data == 'erro') {
              this.erroEditar = true
            }
            if (rsp.data === true || rsp.data === 'true') {
              this.sucessoEditar = true
              this.erroEditar = false
              setTimeout(() => this.voltar(), 2000)
              setTimeout(() => this.checkbox = false, 2000)
              setTimeout(() => this.sucessoEditar = false, 2000)
              setTimeout(() => this.erroEditar = false, 2000)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },

    clear () {
      this.$refs.form.reset()
    }
  },

  watch: {
    servicoSelecionado (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.listaExamesDoMedicoBusca = '' // Limpa a busca ao mudar serviço
        this.expandirResultados = false
        this.retornarExames()
      }
    }
  },

  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}

.v-chip {
  cursor: pointer;
  transition: all 0.3s ease;
}

.v-chip:hover {
  transform: scale(1.05);
}
</style>
